import React from 'react'

import LastTouchQuiz from './LastTouchQuiz'
import IntervalQuiz from './IntervalQuiz'

const PersonListQuizes = ({people}) => {
  if (people.length < 1) {
    return null
  }
  const person = people[0]
  if (!person.interval) {
    return <IntervalQuiz person={person} />
  }
  if (!person._lastTouchDate) {
    return <LastTouchQuiz person={person} />
  }
  return null
}

export default PersonListQuizes



// WEBPACK FOOTER //
// ./src/views/people/PersonListQuizes.js